<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewReview"
            :searchFilters="searchFilters"
            @searchPage="searchReviews"
            @resetFilters="resetFilters"
            @removeItem="removeReview"
            @removeSelectedItems="removeReviews"
            @printList="printReviewsList"
            v-model:printModalVisible="printModalVisible"
            :printTitle="printTitle"
            :pdfUrl="pdfUrl"
            @printExcel="downloadAdvancesExcel"
            @printCSV="downloadAdvancesCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="reviewsList"
            :actions="actions"
            :showTotals=true
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            @handleOpenLink="handleOpenLink"
            :groupingKey=true
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveReview" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="refModalVisible" :title="refTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="ref_modal_loader" @showLoader="showRefModalLoader" @hideLoader="hideRefModalLoader" @closeModal="closeRefModal">
        <DynamicForm 
            :fields="refFormFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="approveReview" @handleReset="handleRefReset"
        />
    </MovableModal>
    <PrintModal v-model:visible="printModalVisible1" :title="printTitle1" >
        <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" type="application/pdf" style="border: none;"></iframe>
    </PrintModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import PrintModal from '@/components/PrintModal.vue';

export default{
    name: 'Salary_Reviews',
    components:{
        PageComponent, MovableModal,DynamicForm,PrintModal
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const { formatDate } = useDateFormatter();
        const { getYear } = useDateFormatter();
        const { getMonth } = useDateFormatter();
        const current_date = new Date();
        const loader = ref('none');
        const modal_loader = ref('none');
        const ref_modal_loader = ref('none');
        const emplComponentKey = ref(0);
        const levComponentKey = ref(0);
        const ledComponentKey = ref(0);
        const idField = 'salary_review_id';
        const addButtonLabel = ref('New Salary Review');
        const addingRight = ref('Adding Salary Reviews');
        const removingRight = ref('Deleting Salary Reviews');
        const rightsModule = ref('HR');
        const title = ref('Salary Review Details');
        const refTitle = ref('Approve Review');
        const printModalVisible = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Print Salary Reviews List');
        const printModalVisible1 = ref(false);
        const printTitle1 = ref('Print Voucher');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const reviewsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const refModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const employeeID = ref('');
        const reviewID = ref('');
        const approvedAmount = ref(0);
        const isEditing = computed(()=> store.state.Salary_Reviews.isEditing);
        const selectedReview = computed(()=> store.state.Salary_Reviews.selectedReview);
        const selectedEmployee = computed(()=> store.state.Salary_Reviews.selectedEmployee);
        const employeeArray = computed(() => store.state.Employees.employeeArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Basic Pay", key:"prev_amount", type: "number"},
            {label: "Review", key:"rev_amount", type: "number"},
            {label: "New Amount", key:"new_amount", type: "number"},
            {label: "Status", key:"approval_status", textColor: "textColor"},
            {label: "Approved By", key:"approved_by"},

        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Review', rightName: 'Editing Salary Reviews'},
            {name: 'approve', icon: 'fa fa-check-circle', title: 'Approve Review', rightName: 'Approving Salary Reviews'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Review', rightName: 'Deleting Salary Reviews'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const employee_name_search = ref('');
        const staff_number_search = ref('');
        const status_search = ref("");
        const from_date_search = ref("");
        const to_date_search = ref("");
        const searchFilters = ref([
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:32,},
            {type:'text', placeholder:"Employee Name...", value: employee_name_search, width:64,},
            {type:'date', placeholder:"From Date...", value: from_date_search, width:36, title: "Date From Search"},
            {type:'date', placeholder:"To Date...", value: to_date_search, width:36, title: "Date To Search"},
            {
                type:'dropdown', placeholder:"Status..", value: status_search, width:32,
                options: [{text:'Pending',value:'Pending'},{text:'Approved',value:'Approved'},{text:'Rejected',value:'Rejected'}]
            },
            
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchEmployees = async() =>{
           await store.dispatch('Employees/fetchEmployees', {company:companyID.value})
        };
        const handleSelectedEmployee = async(option) =>{
            await store.dispatch('Employees/handleSelectedEmployee', option)
            employeeID.value = store.state.Employees.employeeID;
            formFields.value[2].value = store.state.Employees.basicPay;
        };
        const clearSelectedEmployee = async() =>{
            await store.dispatch('Employees/updateState', {employeeID: ''});
            employeeID.value = store.state.Employees.employeeID;
        };
        const formFields = ref([]);
        const employeeValue = computed(() => {
           return (selectedReview.value && selectedReview.value.employee && !employeeID.value) ? selectedReview.value.employee.employee_id : employeeID.value;

        });
        const calculateReview = (value) =>{
            formFields.value[4].value = value - formFields.value[2].value;
        };
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Employee", value: employeeValue.value, componentKey: emplComponentKey,
                    selectOptions: employeeArray, optionSelected: handleSelectedEmployee, required: true,
                    searchPlaceholder: 'Select Employee...', dropdownWidth: '500px', updateValue: selectedEmployee.value,
                    clearSearch: clearSelectedEmployee
                },
                { type: 'date', name: 'date',label: "Date", value: selectedReview.value?.date || '', required: true },
                { type: 'number', name: 'prev_amount',label: "Basic Pay", value: selectedReview.value?.prev_amount || 0, required: false, disabled: true},
                { type: 'number', name: 'new_amount',label: "Revised Amount", value: selectedReview.value?.new_amount || 0, required: true, method: calculateReview},
                { type: 'number', name: 'rev_amount',label: "Review", value: selectedReview.value?.rev_amount || 0, required: false, disabled: true},

            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = 0;
            }
            emplComponentKey.value += 1;
            employeeID.value = '';
        }


        watch([selectedReview, selectedEmployee], () => {
            if (selectedReview.value && selectedEmployee.value) {
                emplComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createReview = async() =>{
            showModalLoader();
            let formData = {
                prev_amount: formFields.value[2].value,
                new_amount: formFields.value[3].value,
                date: formFields.value[1].value,
                employee: employeeID.value,
                employee_id: employeeID.value,
                approval_status: "Pending",
                approved_by: null,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value ==0 && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(employeeValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Salary_Reviews/createSalaryReview', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Salary Review created successfully!');
                        handleReset();
                        emplComponentKey.value += 1;
                        levComponentKey.value += 1;
                    }
                    else {
                        toast.error('An error occurred while creating the Salary Review.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Salary Review: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchReviews();
                }
            }
        }
        const updateReview = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                salary_review: selectedReview.value.salary_review_id,
                prev_amount: formFields.value[2].value,
                new_amount: formFields.value[3].value,
                date: formFields.value[1].value,
                employee: employeeID.value,
                employee_id: employeeID.value,
                approval_status: selectedReview.value.approval_status,
                approved_by: selectedReview.value.approved_by,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value ==0 && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(employeeValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Salary_Reviews/updateSalaryReview', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        emplComponentKey.value += 1;
                        toast.success("Salary Review updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Salary Review.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Salary Review: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Salary_Reviews/updateState",{selectedReview:null})
                    searchReviews();
                }             
            }
        }
        const saveReview = () =>{
            if(isEditing.value == true){
                updateReview();
            }else{
                createReview();
            }
        }
        const removeReview = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    salary_review: selectedIds.value,
                    user: userID.value,
                }
                try{
                    const response = await store.dispatch('Salary_Reviews/deleteSalaryReview',formData)
                    if(response && response.status == 200){
                        toast.success("Salary Review Removed Succesfully");
                        searchReviews();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Salary Review: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Salary Review") 
            }else{
                toast.error("Please Select A Salary Review To Remove")
            }
        }
        const removeReviews = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    salary_review: selectedIds.value,
                    user: userID.value,
                }
                try{
                    const response = await store.dispatch('Salary_Reviews/deleteSalaryReview',formData)
                    if(response && response.status == 200){
                        toast.success("Salary Review(s) Removed Succesfully");
                        searchReviews();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Salary Review: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select A Salary Review To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchReviews = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                from_date: from_date_search.value,
                to_date: to_date_search.value,
                status: status_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/salary-reviews-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                reviewsList.value = response.data.results;
                store.commit('Salary_Reviews/LIST_REVIEWS', reviewsList.value)
                propResults.value = response.data;
                propArrLen.value = reviewsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchReviews(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            staff_number_search.value = "";
            employee_name_search.value = "";
            status_search.value = "";
            from_date_search.value = "";
            to_date_search.value = "";
            searchReviews();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchReviews();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchReviews();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchReviews();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchReviews();
            // scrollToTop();
        }
        const addNewReview = () =>{
            store.dispatch("Salary_Reviews/updateState",{selectedReview:null, selectedEmployee:null});
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Salary_Reviews/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const reviewID = row['salary_review_id'];
                const apprvStatus = row['approval_status'];
                if(apprvStatus != "Pending"){
                    return toast.error(`Cannot Edit ${apprvStatus} Review!`)
                }
                let formData = {
                    company: companyID.value,
                    salary_review: reviewID
                }
                await store.dispatch('Salary_Reviews/fetchSalaryReview',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.333';

            }else if(action == 'delete'){
                const reviewID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    salary_review: reviewID,
                    user: userID.value,
                }
                const response = await store.dispatch('Salary_Reviews/deleteSalaryReview',formData)
                if(response && response.data.msg == "Success"){
                    toast.success("Salary Review Removed Succesfully");
                    searchReviews();
                }
            }else if(action == 'approve'){
                const apprvStatus = row['approval_status'];
                if(apprvStatus != "Pending"){
                    toast.error(`Review Already ${apprvStatus}`)
                }else{    
                    reviewID.value = row[idField];
                    refModalVisible.value = true;
                    flex_basis.value = '1/3';
                    flex_basis_percentage.value = '33.333';
                }
                
            }
        }
        const handleOpenLink = async(row) =>{
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printReviewsList = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                from_date: from_date_search.value,
                to_date: to_date_search.value,
                status: status_search.value,
                company_id: companyID.value,
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-salary-reviews-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob1);
                        pdfUrl.value = url;
                        printModalVisible.value = true;
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadAdvancesExcel = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                status: status_search.value,
                company_id: companyID.value,
            }
            axios.post("api/v1/export-salary-reviews-excel/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Salary Advances.xlsx');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadAdvancesCSV = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            }
            axios.post("api/v1/export-salary-reviews-csv/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Salary Advances.csv');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };

        const refFormFields = ref([
            { type: 'dropdown', name: 'approval_status',label: "Status", value: '', placeholder: "", required: true, options: [{ text: 'Approve', value: 'Approved' }, { text: 'Reject', value: 'Rejected' }] },
        ]);
        const handleRefReset = () =>{
            for(let i=0; i < refFormFields.value.length; i++){
                refFormFields.value[i].value = '';
            }
            reviewID.value = null;
        }
        const showRefModalLoader = () =>{
            ref_modal_loader.value = "block";
        }
        const hideRefModalLoader = () =>{
            ref_modal_loader.value = "none";
        }
        const approveReview = async() =>{
            showRefModalLoader();
            let formData = {
                salary_review: reviewID.value,
                approval_status: refFormFields.value[0].value,
                user: userID.value,
                company: companyID.value
            }
            axios.post(`api/v1/approve-salary-review/`,formData)
            .then((response)=>{
                if(response.data.msg == "Success"){
                    toast.success("Success")
                    closeRefModal();
                    searchReviews();
                }else{
                    toast.error("Error Approving Review")
                }                   
            })
            .catch((error)=>{
                console.log(error.message);
                toast.error(error.message)
                hideRefModalLoader();
            })
            .finally(()=>{
                hideRefModalLoader();
            })
        
        };
        const closeRefModal = () =>{
            refModalVisible.value = false;
            handleRefReset();
            hideRefModalLoader();
        };
        onBeforeMount(()=>{
            searchReviews();
            fetchEmployees();

        })
        return{
            title, searchReviews,resetFilters, addButtonLabel, searchFilters, tableColumns, reviewsList,ref_modal_loader,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewReview, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveReview, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeReview, removeReviews,addingRight,removingRight,rightsModule,printReviewsList,selectSearchQuantity,selectedValue,
            downloadAdvancesCSV,downloadAdvancesExcel,refModalVisible, refTitle, refFormFields, showRefModalLoader, hideRefModalLoader, approveReview, closeRefModal,
            printModalVisible, pdfUrl, printTitle,printModalVisible1,printTitle1,handleOpenLink
        }
    }
};
</script>